import { normalizeMenuPath } from '@/utils/menuPathUtils'

/** Menu SSO (`get-my-menu`) — một số bản ghi dùng `path` thay vì `url`. */
export type MenuLike = {
  url?: string
  path?: string
  type?: string
  isActive?: boolean
  chucNangs?: { ma: string }[]
}

const pickUrl = (menu: MenuLike): string => {
  const url = menu.url
  if (url != null && String(url).trim() !== '') return String(url)
  const path = menu.path
  if (path != null && String(path).trim() !== '') return String(path)
  return ''
}

/** Từ menu SSO → dữ liệu Redux cho `useMenuChucNang`. */
export const processWebMenu = (menus: MenuLike[]) => {
  const webMenus = menus.filter((menu) => {
    if (menu.type != null && String(menu.type) !== '') {
      return menu.type === 'WEBAPP' && menu.isActive !== false
    }
    if (menu.isActive != null) return menu.isActive
    return true
  })

  const webUrls = webMenus.map((menu) => normalizeMenuPath(pickUrl(menu))).filter((url) => url.length > 0)

  const webChucNangs = webMenus
    .map((menu) => {
      const url = normalizeMenuPath(pickUrl(menu))
      const chucNangs = (menu.chucNangs ?? []).map((item) => item.ma)
      return { url, chucNangs }
    })
    .filter((item) => item.url && item.chucNangs.length > 0)

  const webChucNangAll = webMenus
    .flatMap((menu) => (menu.chucNangs ?? []).map((item) => item.ma))
    .filter((value, index, self) => self.indexOf(value) === index)

  return {
    webUrls,
    webChucNangs,
    webChucNangAll,
  }
}
